import { Add, Cancel, DeleteOutline, RemoveCircle, Search, Tune } from '@mui/icons-material'
import {
  Autocomplete,
  Avatar,
  Checkbox,
  FormControl,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  OutlinedInput,
  Paper,
  TextField,
  Tooltip,
} from "@mui/material";
import React, { useEffect, useMemo, useState } from 'react'
import { DataGrid } from '@mui/x-data-grid'
import { Modal } from 'react-bootstrap'
import { Controller, useForm } from 'react-hook-form'
import axios from 'axios';
import pending from '../../assets/images/pending.png';
import check from '../../assets/images/Confirmed.png'
import defaultImage from '../../assets/images/default.png'
import { useSelector } from 'react-redux'
import {  Eye } from 'lucide-react'
import { toast } from 'react-toastify'
import './Staff.css'
import DeleteModal from '../../components/Modals/DeleteModal'
import DatePickerDMY from '../../components/DatePickerDMY';

      const Notes = () => {
  
      const [filterDate, setFilterDate] = useState("");
      const [anchorEl, setAnchorEl] = useState(null);
      const open = Boolean(anchorEl);

      const statuses = [{title:"Unread", icon:pending,id:"1"},{title:"Read", icon:check,id:"2"}]
      
        // edits from mostafa

      const { user } = useSelector((state) => state.auth);

      const token = user?.token;

      const newBaseUrl = "https://estbn.com/EstbnNew/public";

      const headers = {
    Authorization: "Bearer " + token,
      };

          const formatDate = (dateStr) => {
            if (!dateStr) return "";
            const date = new Date(dateStr);
            return date.toLocaleDateString("en-US", {
              year: "numeric",
              month: "short",
              day: "numeric",
            });
          };

        // notes & table data 

        const [notes, setNotes] = useState([])
        const [searchTerm, setSearchTerm] = useState("");

        const getNotes = async() => {
          try {
            let response = await axios.get(
              `${newBaseUrl}/api/portal/get-all-notes`,
              {
                headers,
              },
            );
            console.log(response.data.data.notes);
            setNotes(response.data.data.notes);
          } catch (error) {
            console.log(error);
          }
        }

          const NotesColumns = [
            {
              field: "Id",
              headerName: "Note Id",
              flex: 0.6,
              minWidth: 60,
            },
            {
              field: "recipients",
              headerName: "Employee Name",
              flex: 1,
              minWidth: 200,
              renderCell: (params) => {
                const users = params.value || [];
                if (!users.length) return "—";
                const firstUser = users[0];
                const restCount = users.length - 1;
                return (
                  <Tooltip
                    arrow
                    placement="bottom-start"
                    title={
                      <div
                        style={{
                          borderRadius: 8,
                          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                          padding: 5,
                          maxHeight: 250,
                          overflowY: "auto",
                          minWidth: 200,
                        }}
                      >
                        {users.map((user, index) => (
                          <div
                            key={index}
                            style={{
                              padding: "4px",
                              fontSize: 14,
                              whiteSpace: "nowrap",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <div>
                              <img
                                src={
                                  user?.profile_photo_path !== null
                                    ? `${newBaseUrl}${user.profile_photo_path}`
                                    : defaultImage
                                }
                                width={20}
                                style={{ marginRight: 5, borderRadius: "50%" }}
                                alt=""
                              />
                              {user.name}
                            </div>
                            <div>
                              <img
                                src={user.is_read ? check : pending}
                                alt=""
                                width={20}
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    }
                  >
                    <div
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        gap: 5,
                      }}
                    >
                      <img
                        src={
                          firstUser?.profile_photo_path !== null
                            ? `${newBaseUrl}${firstUser.profile_photo_path}`
                            : defaultImage
                        }
                        width={25}
                        style={{ marginRight: 5, borderRadius: "50%" }}
                        alt=""
                      />
                      <span>{firstUser.name}</span>
                      {restCount > 0 && (
                        <span style={{ fontWeight: 500 }}>
                          +{restCount} others
                        </span>
                      )}
                    </div>
                  </Tooltip>
                );
              },
            },
            {
              field: "Title",
              headerName: "Title",
              flex: 1,
              minWidth: 130,
            },
            {
              field: "Created",
              headerName: "Created at",
              flex: 0.9,
              minWidth: 110,
            },
            {
              field: "unreadCount",
              headerName: "Status",
              width: 150,
              renderCell: (params) => {
                const count = params.value;
                return count > 0 ? (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={pending}
                      alt=""
                      width={20}
                      style={{ marginRight: 5 }}
                    />
                    Unread {count}
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={check}
                      alt=""
                      width={20}
                      style={{ marginRight: 5 }}
                    />
                    Read
                  </div>
                );
              },
            },
            {
              field: "Actions",
              headerName: "Actions",
              flex: 0.8,
              minWidth: 90,
              renderCell: (params) => {
                  const handleView = (event) => {
                    event.stopPropagation();
                    handleViewModalOpen(params.row.rawData);
                };
                const handleDelete = (event) => {
                  event.stopPropagation();
                  confirmDelete(params.row.id);
                };
                return (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                      width: "100%",
                      overflow: "visible",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <div style={{ width: "25%" }}>
                      <IconButton
                        onClick={handleView}
                        color="default"
                        aria-label="edit"
                      >
                        <Eye  />{" "}
                      </IconButton>
                    </div>
                    <div style={{ width: "25%" }} >
                      <IconButton
                        onClick={handleDelete}
                        color="error"
                        aria-label="delete"
                      >
                        <DeleteOutline />
                      </IconButton>
                    </div>
                  </div>
                );
              },
            },
          ];
        
          const paginationModel = { page: 0, pageSize: 10 };
        
          const rows = notes
            .filter((note) => {
              const matchesSearch =
                note.title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                note.notes?.toLowerCase().includes(searchTerm.toLowerCase());

              return matchesSearch;
            })
            .map((note) => ({
              id: note.id,
              Id: note.id,
              recipients: note.recipients,
              Title: note.title || "",
              Created: formatDate(note.created_at) || "None",
              unreadCount: note.unread_count,
              Actions: "",
              rawData: note,
            }));
        
        //  view modal data
        
        const [viewData, setViewData] = useState(null);

        const [viewModalOpen, setViewModalOpen] = useState(false);

        const handleViewModalOpen = (data) => {
          setViewData(data);
          console.log(data);
         setViewModalOpen(true);
        };
        
        const handleViewModalClose = () => { 
          setViewModalOpen(false);
        };

        // add note modal

        const [showNoteModal, setShowNoteModal] = useState(false)
  
        const handleNoteModalShow = () => {
          reset({
            title: "",
            notes: "",
            staff_type: null,
            members: [],
          });

          setSelectedType(null);
      setShowNoteModal(true)
        }
        
        const handleNoteModalClose = () =>{
        setShowNoteModal(false)
        }

        const types = [
          { id: "1", title: "Operations", value: "operator" },
          { id: "2", title: "Technical" , value :'stuff' },
          { id: "3", title: "All Staff" , value :'all' },
        ];

        const [selectedType, setSelectedType] = useState(null);

        const [staffs, setStaffs] = useState([]);
        
        const [operators, setOperators] = useState([]);
        
        const getOperators = async() => {
          try {
            let response = await axios.get(
              `${newBaseUrl}/api/portal/operators`,
              {
                headers,
              },
            );
            console.log(response.data.data.operators);
            setOperators(response.data.data.operators);
          } catch (error) {
            console.log(error);
          }
        }

        const getStaffs = async () => {
          try {
            let response = await axios.get(
              `${newBaseUrl}/api/portal/stuffs`,
              {
                headers,
              },
            );
            console.log(response.data.data.stuffs);
            setStaffs(response.data.data.stuffs);
          } catch (error) {
            console.log(error);
          }
        };

        const membersOptions = useMemo(() => {
       if (!selectedType) return [];

       if (selectedType.value === "stuff") {
    return staffs.map((item) => ({
      id: item.id,
      name: item.name,
      avatar: item.profile_photo_url,
      type: "stuff",
    }));
       }

       if (selectedType.value === "operator") {
    return operators.map((item) => ({
      id: item.id,
      name: item.name,
      avatar: item.profile_photo_path,
      type: "operator",
    }));
       }

       return [];
        }, [selectedType, staffs, operators]);
 
        const onSubmit = async (data) => {
          try {
            const formData = new FormData();

            formData.append("title", data.title);
            formData.append("notes", data.notes);

            // لو all
            if (selectedType.value === "all") {
              formData.append("recipients[0][type]", "all");
            } else {
              data.members.forEach((member, index) => {
                formData.append(
                  `recipients[${index}][type]`,
                  selectedType.value,
                );

                formData.append(`recipients[${index}][id]`, member.id);
              });
            }

            await axios.post(
              "https://estbn.com/EstbnNew/public/api/stuff/note",
              formData,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              },
            );
            toast.success("Note added successfully");
            handleNoteModalClose();
            getNotes();
          } catch (err) {
            console.log(err);
            toast.error("Error");
          }
        };

        const { control, handleSubmit, setValue, register, reset } = useForm({
  defaultValues: {
    title: "",
    notes: "",
    staff_type: null,
    members: [],
  },
        });

        // delete note functions
        
          const [showDelete, setShowDelete] = useState(false);
          const [noteId, setNoteId] = useState(null);
        
          const handleDeleteClose = () => {
            setShowDelete(false);
            setNoteId(null);
          };
        
          const confirmDelete = (id) => {
            setShowDelete(true);
            setNoteId(id);
          };
        
          const deleteNote = async () => {
            try {
              let response = await axios.delete(
                `${newBaseUrl}/api/portal/stuffs/${noteId}/delete-note`,
                {
                  headers,
                }
              );
              toast.warning("Note Deleted successfully", { autoClose: 3000 });
              console.log(response);
              handleDeleteClose();
              getNotes();
            } catch (error) {
              toast.error("Failed To Delete This Note.");
              console.log(error.message);
            }
          };

        // effects 
        
        useEffect(() => {
          getNotes();
          getOperators();
          getStaffs();
        }, [])

  return (
    <>
      {/* add note */}
      <Modal
        show={showNoteModal}
        onHide={handleNoteModalClose}
        dialogClassName=""
        size='md'
      >
        <Modal.Header closeButton>
          <Modal.Title className="m-0 w-100">Add Note</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="my-2">
            <form onSubmit={handleSubmit(onSubmit)}>
              {/* title */}
              <div className="">
                <label htmlFor="title" className="field-label">Title</label>
                <TextField
                  id="title"
                  type="text"
                  size="small"
                  className="w-100"
                  placeholder="Add note title"
                  {...register("title")}
                />
              </div>
              {/* Target Audience  */}
              <div className="my-1">
                <label className="field-label">Target Audience</label>
                <Controller
                  name="staff_type"
                  control={control}
                  render={({ field }) => (
                    <Autocomplete
                      options={types}
                      value={selectedType}
                      getOptionLabel={(option) => option.title}
                      isOptionEqualToValue={(o, v) => o.id === v.id}
                      onChange={(e, newValue) => {
                        field.onChange(newValue);
                        setSelectedType(newValue);
                        setValue("members", []);
                      }}
                      renderOption={(props, option, { selected }) => (
                        <li
                          {...props}
                          key={option.id}
                          className="audience-option"
                        >
                          <div className="audience-option-content p-2">
                            <div className="audience-info cursor-pointer">
                              <span className="audience-title">
                                {option.title}
                              </span>
                            </div>
                          </div>

                          {selected && (
                            <div className="audience-selected-indicator" />
                          )}
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                          placeholder="Select target audience"
                          className="professional-input"
                        />
                      )}
                    />
                  )}
                />
              </div>
              {/* members */}
              <div className="my-1">
                <label htmlFor="members" className="field-label">Members</label>
                <Controller
                  name="members"
                  control={control}
                  render={({ field }) => {
                    const isDisabled = selectedType?.value === "all";
                    return (
                      <div className="members-wrapper">
                        <Autocomplete
                          multiple
                          disableCloseOnSelect
                          disabled={isDisabled}
                          options={membersOptions}
                          value={field.value || []}
                          getOptionLabel={(option) => option.name}
                          isOptionEqualToValue={(o, v) => o.id === v.id}
                          onChange={(e, newValue) => field.onChange(newValue)}
                          renderTags={() => null} // 👈 hide inside tags
                          renderOption={(props, option, { selected }) => (
                            <li
                              {...props}
                              key={option.id}
                              className="member-option "
                            >
                              <div className="d-flex justify-content-start align-items-center gap-2 my-2 cursor-pointer">
                                <Checkbox checked={selected} />
                                <Avatar src={option.avatar} />
                                <div className="member-info">
                                  <span className="member-name">
                                    {option.name}
                                  </span>
                                </div>
                              </div>
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              size="small"
                              placeholder="Select members"
                            />
                          )}
                        />
                        {field.value?.length > 0 && (
                          <div className="selected-members-container">
                            {field.value.map((member) => (
                              <div
                                key={member.id}
                                className="selected-member-card d-flex justify-content-between align-items-center my-1"
                              >
                                <div className=' d-flex justify-content-start align-items-center gap-2'>
                                  <Avatar src={member.avatar} />
                                  <div className="selected-member-info">
                                    <strong>{member.name}</strong>
                                  </div>
                                </div>
                                <IconButton
                                  size="small"
                                  onClick={() =>
                                    field.onChange(
                                      field.value.filter(
                                        (m) => m.id !== member.id,
                                      ),
                                    )
                                  }
                                >
                                  <RemoveCircle
                                    color="error"
                                    fontSize="small"
                                  />
                                </IconButton>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    );
                  }}
                />
              </div>
              {/* note */}
              <div className="my-1">
                <label htmlFor="note-content" className="field-label">Note Content</label>
                <textarea
                  id="note-content"
                  className="w-100"
                  style={{
                    padding: 10,
                    borderRadius: 5,
                    border: "solid 2px #D8D8D8",
                  }}
                  rows={3}
                  {...register("notes")}
                  placeholder="Add note content"
                />
              </div>
              <div className="d-flex justify-content-center align-items-center gap-3 mt-3">
                <button onClick={handleNoteModalClose} type='button' className="btn btn-light main-text-color px-5">
                  Cancel
                </button>
                <button type="submit" className="btn btn-dark px-5">
                  Save
                </button>
              </div>
            </form>
          </div>
        </Modal.Body>
      </Modal>
      {/* view note modal */}
      <Modal show={viewModalOpen} onHide={handleViewModalClose}>
        <Modal.Header className="categories_header bg-white border-0 pb-0">
          <Modal.Title className="categories_title d-flex justify-content-between align-items-center w-100 pb-0 mb-0">
            <p className=" my-0 small fw-bold">Note #{viewData?.id}</p>
            <div className=" cursor" onClick={handleViewModalClose}>
              <Cancel />
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-1 px-4">
          <div>
            <h5 className="fw-semibold text-black">{viewData?.title}</h5>
            <p className="text-black">{viewData?.notes}</p>
            {viewData?.recipients && viewData?.recipients.length > 0 && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  color: "#000",
                  gap: 5,
                }}
              >
                <img
                  src={
                    viewData?.recipients[0]?.profile_photo_path !== null
                      ? `${newBaseUrl}${viewData?.recipients[0]?.profile_photo_path}`
                      : defaultImage
                  }
                  width={25}
                  style={{ marginRight: 5, borderRadius: "50%" }}
                  alt=""
                />
                <span>{viewData?.recipients[0]?.name}</span>
                {viewData?.recipients?.length > 1 && (
                  <span style={{ fontWeight: 500 }}>
                    +{viewData?.recipients?.length - 1} others
                  </span>
                )}
              </div>
            )}
            <div className="w-75 d-flex justify-content-between align-items-center pt-3 small text-black">
              <p>Created at : {formatDate(viewData?.created_at)}</p>
              <p>Created by : {viewData?.creator?.name}</p>
            </div>
          </div>
        </Modal.Body>
      </Modal>
           {/* delete note */}
            <DeleteModal
              showDelete={showDelete}
              handleDeleteClose={handleDeleteClose}
              textMessage={" Are you sure you want to delete this note?"}
              deleteFunction={deleteNote}
            />
      <div className="m-4">
        {/* Header Note */}
        <div className="">
          <div className="d-flex justify-content-between align-items-center">
            <h5 className="m-0">Staff Notes</h5>
            <button onClick={handleNoteModalShow} className="btn btn-light">
              <Add sx={{ marginInline: "3px" }} />
              Add Note
            </button>
          </div>
          <div className="d-flex align-items-center justify-content-between my-3">
            <div
              className="d-flex align-items-center gap-3"
              style={{ width: "70%" }}
            >
              <div className="w-50">
                <FormControl
                  className="m-0"
                  fullWidth
                  variant="outlined"
                  size="small"
                >
                  <OutlinedInput
                    id="search-orders"
                    placeholder="Search for note ID, employee name, or date ..."
                    type="text"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton>
                          <Search />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </div>
          <div className="w-25 d-flex align-items-center gap-2">
            <DatePickerDMY
              value={filterDate}
              onChange={(iso) => setFilterDate(iso)}
            />
            {filterDate && (
              <button
                type="button"
                className="btn btn-sm btn-light"
                style={{ padding: "2px 6px", fontSize: "12px" }}
                onClick={() => setFilterDate("")}
              >
                ✕
              </button>
            )}
          </div>
            </div>
            <div className="">
              <div
                onClick={(e) => setAnchorEl(e.currentTarget)}
                className="btn btn-light"
              >
                <Tune style={{ cursor: "pointer" }} />
              </div>

              <Menu
                className="my-1"
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
                PaperProps={{
                  sx: {
                    p: 1,
                    minWidth: 150,
                    backgroundColor: "#F9F9F9",
                    borderRadius: "10px",
                  },
                }}
              >
                {statuses.map((item) => (
                  <div className="">
                    <MenuItem
                      key={item.value}
                      onClick={() => {
                        console.log(item.value);
                        setAnchorEl(null);
                      }}
                    >
                      <div className="p-2 d-flex gap-3 align-items-center">
                        <img src={item.icon} alt="" />
                        <div className="label-size m-0">{item.title}</div>
                      </div>
                    </MenuItem>
                  </div>
                ))}
              </Menu>
            </div>
          </div>
        </div>
        {/* Table Note */}
        <div className="my-4">
          <div className="data-grid-small">
            <Paper sx={{ height: "auto", width: "100%" }}>
              <DataGrid
                rows={rows}
                columns={NotesColumns}
                initialState={{ pagination: { paginationModel } }}
                pageSizeOptions={[5, 10, 20, 50]}
                checkboxSelection
                sx={{ overflow: "hidden" }}
                slotProps={{
                  pagination: {
                    sx: {
                      justifyContent: "center",
                      display: "flex",
                      alignItems: "center",
                    },
                  },
                }}
              />
            </Paper>
          </div>
        </div>
      </div>
    </>
  );
}

export default Notes